import { put, takeLatest } from 'redux-saga/effects'
import { SignaturesConstants } from '../store/signatures.constants'
import { select } from '@redux-saga/core/effects'
import { getSignaturesSelector } from '../selectors/getSignatures.selector'
import {
  setAmbulanceCrewSignature,
  setRepresentativeSignature,
  setPatientSignature,
  setWitnessSignature,
  setCrewSignature,
  setReceivingFacilitySignature,
  setRepresentativeSignatureDt,
  setAmbulanceSignatureDt,
  setCrewSignatureDt,
  setPatientSignatureDt,
  setReceivingFacilitySignatureDt,
  setWitnessSignatureDt,
  setWitnessPrintedName,
  setWitnessPhone,
  setWitnessAddress,
  setSelectedSignatureType,
  setSignatureSection,
  setSectionTwoSelectedOptionIncapableOfSigning,
  setSectionTwoReasonIncapableOfSigning,
  setSectionThreeSelectedOptionIncapableOfSigning,
  setSectionThreeReasonIncapableOfSigning,
  setCrew,
  setReceivingFacilityPrintedName,
  setReceivingFacilityTitle,
  setRepresentativePrintedName,
  setRepresentativePhone,
  setRepresentativeAddress,
  setSectionTwoAuthorizedRepresentative,
  setIsMark,
} from '../store/signatures.actions'
import { ISignaturesState } from '../store/signatures.types'

export function* deleteSignatures() {
  const signatureState: ISignaturesState = yield select(getSignaturesSelector)
  const { selectedSignatureType, chips, isMark } = signatureState

  const dateTime = ''
  const url = null

  if (selectedSignatureType?.signatureType === SignaturesConstants.PATIENT) {
    yield put(setPatientSignature(url))
    yield put(setPatientSignatureDt(dateTime))
    if (isMark) yield put(setIsMark(false))
  } else if (selectedSignatureType?.signatureType === SignaturesConstants.WITNESS) {
    yield put(setWitnessSignature(url))
    yield put(setWitnessSignatureDt(dateTime))
    yield put(setWitnessPrintedName(''))
    yield put(setWitnessPhone(''))
    yield put(setWitnessAddress(''))
    yield put(setIsMark(false))
  } else if (selectedSignatureType?.signatureType === SignaturesConstants.AMBULANCE) {
    yield put(setAmbulanceCrewSignature(url))
    yield put(setAmbulanceSignatureDt(dateTime))
  } else if (selectedSignatureType?.signatureType === SignaturesConstants.REPRESENTATIVE) {
    yield put(setRepresentativeSignature(url))
    yield put(setRepresentativeSignatureDt(dateTime))
    yield put(setSectionTwoSelectedOptionIncapableOfSigning(null))
    yield put(setSectionTwoReasonIncapableOfSigning(''))
    yield put(setRepresentativePrintedName(''))
    yield put(setRepresentativePhone(''))
    yield put(setRepresentativeAddress(''))
    yield put(setSectionTwoAuthorizedRepresentative(null))
  } else if (selectedSignatureType?.signatureType === SignaturesConstants.CREW) {
    yield put(setCrewSignature(url))
    yield put(setCrewSignatureDt(dateTime))
    yield put(setCrew(null))
    if (!chips.some((chip) => chip.option?.signatureType === SignaturesConstants.RECEIVING)) {
      yield put(setSectionThreeSelectedOptionIncapableOfSigning(null))
      yield put(setSectionThreeReasonIncapableOfSigning(''))
    }
  } else if (selectedSignatureType?.signatureType === SignaturesConstants.RECEIVING) {
    yield put(setReceivingFacilitySignature(url))
    yield put(setReceivingFacilitySignatureDt(dateTime))
    yield put(setReceivingFacilityPrintedName(''))
    yield put(setReceivingFacilityTitle(''))
    if (!chips.some((chip) => chip.option?.signatureType === SignaturesConstants.CREW)) {
      yield put(setSectionThreeSelectedOptionIncapableOfSigning(null))
      yield put(setSectionThreeReasonIncapableOfSigning(''))
    }
  }

  yield put(setSelectedSignatureType(null))
  yield put(setSignatureSection(null))
}

export function* deleteSignaturesSaga() {
  yield takeLatest([SignaturesConstants.DELETE_SIGNATURE_TYPE], deleteSignatures)
}
